module.exports = __webpack_public_path__ + "img/watermark.5a9587c3.png";